import Signature from './AbstractSignature';
import { CreateElement, VNode } from 'vue';
import { ChildParams, referencesMethod } from '@/templates/References';

export default function JavaSignatureFactory(kind: string) {
  switch (kind) {
    case 'method':
      return JavaMethodSignature;
    case 'prop':
      return JavaPropertySignature;
    case 'constructor':
      return JavaMethodSignature;
    default:
      return {
        getSignature(_method: any): null {
          return null;
        },
      };
  }
}

class JavaMethodSignature extends Signature {
  public static LANG = 'java';

  public static getSignature(method: referencesMethod): (h: CreateElement) => VNode {
    const returnsType = this.returnsType(method.returns);
    const paramSignatures = this.paramSignatures(method.params);
    return (h) =>
      h('code', [
        returnsType(h),
        h('span', { class: 'token function' }, ` ${method.title}`),
        h('span', { class: 'token punctuation' }, '('),
        paramSignatures(h),
        h('span', { class: 'token punctuation' }, ')'),
      ]);
  }

  private static paramSignatures(paramSignatures: ChildParams[]): (h: CreateElement) => VNode {
    if (!paramSignatures) return (h) => h();

    return (h) =>
      h(
        'span',
        paramSignatures.map((val: ChildParams, idx: number) => {
          return h('span', [
            val.types ? this.returnsType(val.types)(h) : '',
            ` ${val.title}`,
            !(idx === paramSignatures.length - 1)
              ? h('span', { class: 'token punctuation' }, ', ')
              : '',
          ]);
        })
      );
  }
}

class JavaPropertySignature extends Signature {
  public static LANG = 'java';

  public static getSignature(property: any): (h: CreateElement) => VNode {
    const returnsType = this.returnsType(property.returns);

    return (h) =>
      h('code', [
        h('span', { class: 'token function' }, 'public '),
        returnsType(h),
        ` ${property.title}`,
      ]);
  }
}
